const clear = (): Promise<boolean> => {
  if ('caches' in window) {
    return caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
      .then(() => true);
  }
  return Promise.resolve(false);
};

const clearStaleUserSessions = (userToken: string | undefined): Promise<boolean> => {
  if ('caches' in window) {
    return caches
      .keys()
      .then((keys) => keys.some((key) => key.indexOf(userToken ?? '') > -1))
      .then((response) => {
        if (!response) {
          return clear();
        }
        return true;
      });
  }
  return Promise.resolve(false);
};

export default { clear, clearStaleUserSessions };
